import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

const Wrap = styled.section`
  padding: 6rem 2rem;
  max-width: 720px;
  margin: 0 auto;
  text-align: center;
`;

const Code = styled.p`
  font-family: var(--font-heading);
  font-size: 4rem;
  font-weight: 700;
  color: var(--accent-color);
  margin: 0 0 1rem;
  line-height: 1;
`;

const Title = styled.h1`
  color: #333;
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  font-family: var(--font-heading);
`;

const Body = styled.p`
  color: #555;
  font-size: 1.1rem;
  line-height: 1.75;
  margin: 0 auto 2.5rem;
  max-width: 520px;
`;

const Links = styled.nav`
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
`;

const Primary = styled(Link)`
  background-color: var(--primary-color);
  color: #fff;
  font-weight: 700;
  padding: 0.85rem 2rem;
  border-radius: 100px;
  text-decoration: none;

  &:hover {
    background-color: #5a8a87;
    color: #fff;
  }
`;

const Secondary = styled(Link)`
  background-color: transparent;
  color: var(--primary-color);
  font-weight: 600;
  padding: 0.85rem 2rem;
  border-radius: 100px;
  border: 2px solid var(--primary-color);
  text-decoration: none;

  &:hover {
    background-color: rgba(122,166,162,0.08);
  }
`;

const NotFound = () => (
  <Layout
    title="Page Not Found"
    description="The page you're looking for doesn't exist. Browse our workshops, events, resources, or get in touch."
    path="/404"
    noindex
  >
    <Wrap>
      <Code>404</Code>
      <Title>Page not found</Title>
      <Body>
        The page you're looking for may have moved or never existed. Here are some places to start instead.
      </Body>
      <Links>
        <Primary to="/">Home</Primary>
        <Secondary to="/workshops">Workshops</Secondary>
        <Secondary to="/events">Events</Secondary>
        <Secondary to="/resources">Resources</Secondary>
        <Secondary to="/about">About</Secondary>
        <Secondary to="/contact">Contact</Secondary>
      </Links>
    </Wrap>
  </Layout>
);

export default NotFound;
